import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { findNivel } from '@BUP/services/BraveUp'
import { LocationContext } from '@BUP/contexts/LocationContext'
import ViewResourcesButton from './ViewResourcesButton'
import ResultsButton from './results-button'
import styles from './sociogram-table.module.scss'
import UpdateSurveyButton from '../../Buttons/update-survey-button'

const ActionsCell = ({ survey, isMultiCourse, error, participantsTerminated }) => {
  const i18n = useTranslation()
  const locale = useContext(LocationContext)
  const lang = locale.locale

  const { isActive, isDone, resource, courses } = survey

  if (!courses || courses.length === 0) {
    return (
      <div className={styles.actions_cell_wrapper}>
        <span className={styles.actions_cell_text}>{i18n.t('pages.data.sociogram.activeSociogramEce.noCoursesMessage')}</span>
      </div>
    )
  }

  const course = courses[0]
  const nivel = lang ? findNivel(lang, course) : null
  const splitNivel = nivel && nivel.id.split(':')[1]
  const surveyName = isMultiCourse ? i18n.t(`common.resources.course.values.tags.nivel.${splitNivel}`) : course.name

  const surveyIsDone = !isActive && isDone

  if (!surveyIsDone) {
    return (
      <div
        className={styles.actions_cell_wrapper}
        data-test='cell-wrapper-update-survey-button'
      >
        <UpdateSurveyButton
          survey={survey}
          size='small'
        />
      </div>
    )
  }

  return (
    <div
      className={styles.actions_cell_wrapper}
      data-test='cell-wrapper-simple-results-button'
    >
      <ResultsButton
        isMultiCourse={isMultiCourse}
        survey={survey}
        surveyName={surveyName}
        participantsTerminated={participantsTerminated}
      />
      {!isMultiCourse && (
        <div className={styles.resources_button_wrapper}>
          <ViewResourcesButton
            buttonText={`${i18n.t('pages.data.sociogram.activeSociogramEce.table.resourcesButton')}`}
            resource={resource}
            error={error}
            surveyName={surveyName}
          />
        </div>
      )}
    </div>
  )
}

export default ActionsCell
